import { render, staticRenderFns } from "./add-dialog.vue?vue&type=template&id=cdcf7fbe&scoped=true"
import script from "./add-dialog.vue?vue&type=script&lang=js"
export * from "./add-dialog.vue?vue&type=script&lang=js"
import style0 from "./add-dialog.vue?vue&type=style&index=0&id=cdcf7fbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdcf7fbe",
  null
  
)

export default component.exports